import { Lottie } from "@/components/ui/lottie"

import starsLoader from "../assets/stars-loader.json"

/** Full-screen loader shown while a returning sign-in redirect resolves and data syncs. */
export function SignInLoader() {
  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center bg-dark-base px-4 text-center font-body text-purple-light">
      <Lottie animationData={starsLoader} className="aspect-square w-full max-w-[220px]" />
      <h1 className="mt-8 font-display text-2xl font-medium text-purple-light">
        Signing you in...
      </h1>
      <p className="mt-2 text-base text-purple-light/70">
        Please wait a moment while we sync your data
      </p>
    </div>
  )
}
